import GameModel from "../../../core/src/model/GameModel";
import Utils from "../../../core/src/utils/Utils";
import GetGameRequest from "./GetGameRequest";

export default class LoadGameSettingsRequest extends GetGameRequest {
  get requestData(): any {
    let userId = GameModel?.playerConfig?.userId || undefined;
    return {
      "action": "loadGameConfiguration",
      "gameId":  GameModel.apiConfig.gameId,
      "userId": userId,
      "authToken": GameModel.authToken,
      "currency": GameModel.currency,
      "casino": GameModel.casino,
      'serverVersion': GameModel.apiConfig.serverVersion,
      'gameVersion': Utils.isNullOrWhiteSpace(GameModel.apiConfig.gameVersion) ? GameModel?.gameVersion : GameModel.apiConfig.gameVersion,
      'deviceInfo': Utils.getDeviceInfo(),
      "playerToken": GameModel.playerToken
    }
  }

}